module.exports = __webpack_public_path__ + "img/recipt.f293bc54.svg";